import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Account } from "./type";
import { RootState } from "..";

//Adapter 영역 - 선언부
const initialState: Account = {
  isConnect: false,
  isInWhisper: false,
  userInfo: {
    address: "",
    description: "",
    id: 0,
    is_authorized: false,
    kyc_application_id: 0,
    kyc_status: false,
    new_address: "",
    nickname: "",
    profile_image: "",
    token: {
      access: {
        token: '',
        expires: '',
      },
    },
    whisper_image: 0,
  },
};

//Slice 영역 - 선언부
const accountSlice = createSlice({
  name: "account",
  initialState: initialState,
  reducers: {
    setAccount(state, action: PayloadAction<Account>) {
      return action.payload;
    },
    clearAccount(state) {
      return initialState;
    },
  },
});

//Action 영역
export const { setAccount, clearAccount } = accountSlice.actions;

//Store 데이터 영역
export const account_info = (state: RootState) => state.account;

//Reducer 영역
export default accountSlice.reducer;
